import { render, staticRenderFns } from "./VFlatButton.vue?vue&type=template&id=a5204abe&scoped=true&"
import script from "./VFlatButton.vue?vue&type=script&lang=js&"
export * from "./VFlatButton.vue?vue&type=script&lang=js&"
import style0 from "./VFlatButton.vue?vue&type=style&index=0&id=a5204abe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5204abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/myretro/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5204abe')) {
      api.createRecord('a5204abe', component.options)
    } else {
      api.reload('a5204abe', component.options)
    }
    module.hot.accept("./VFlatButton.vue?vue&type=template&id=a5204abe&scoped=true&", function () {
      api.rerender('a5204abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFlatButton.vue"
export default component.exports